module.exports = __webpack_public_path__ + "img/envelope.b8cde5ad.svg";